import { PDFDownloadLink } from "@react-pdf/renderer";
import CaixaReportPDF from "./CaixaReportPDF.js";
import { Button } from "react-bootstrap";
import { FileText } from "lucide-react";

const DownloadButtonCaixa = ({ filtros, data, totals }) => (
  <PDFDownloadLink
    document={<CaixaReportPDF filtros={filtros} data={data} totals={totals} />}
    fileName="relatorio_caixa.pdf">
    {({ loading }) => (
      <Button
      >
        <FileText size={16} className="me-2" />
        {loading ? "Gerando PDF…" : "Baixar PDF"}
      </Button>
      )}
  </PDFDownloadLink>
);

export default DownloadButtonCaixa;
